<template>
  <a href="javascript:void(0)" class="bs-wizard-dot"></a>
</template>

<script>
export default {
  name: "bs-wizard-dot"
};
</script>

<style>
.bs-wizard > .bs-wizard-step > .bs-wizard-dot {
  position: absolute;
  width: 30px;
  height: 30px;
  display: block;
  background: #15dabd;
  top: 45px;
  left: 50%;
  margin-top: -15px;
  margin-left: -15px;
  border-radius: 50%;
}
.bs-wizard > .bs-wizard-step > .bs-wizard-dot:after {
  content: " ";
  width: 14px;
  height: 14px;
  background: #17a08c;
  border-radius: 50px;
  position: absolute;
  top: 8px;
  left: 8px;
}
.bs-wizard > .bs-wizard-step.active > .bs-wizard-dot {
  background-color: #fbe8aa;
}
.bs-wizard > .bs-wizard-step.active > .bs-wizard-dot:after {
  background-color: #fbbd19;
}
.bs-wizard > .bs-wizard-step.disabled > .bs-wizard-dot {
  background-color: #e4e7ea;
}
.bs-wizard > .bs-wizard-step.disabled > .bs-wizard-dot:after {
  opacity: 0;
}
.bs-wizard > .bs-wizard-step.disabled a.bs-wizard-dot {
  pointer-events: none;
}
</style>



// WEBPACK FOOTER //
// src/components/UIComponents/BsWizard/BsWizardDot.vue